import DimensionInput from "components/Common/DimensionInput"
import React from "react"
import { Input, Table } from "reactstrap"

export default function Dimensions(props) {
  const { config } = props

  // 上り寸法
  const onTextInputChange = params => {
    const { name: _key, val, obj, idx } = params
    const _obj = {
      ...config.payload.pants.dimensions[idx],
    }
    switch (_key) {
      case "nude": {
        _obj.nude = val
        _obj.riseDimension =
          parseFloat(val || 0) + parseFloat(_obj.correctionValue || 0)
        break
      }
      case "correctionValue": {
        _obj.riseDimension =
          parseFloat(_obj.nude || 0) + parseFloat(_obj.correctionValue || 0)
        _obj.correctionValue = val
        break
      }

      case "riseDimension": {
        _obj.correctionValue = parseFloat(val || 0) - parseFloat(_obj.nude || 0)
        _obj.riseDimension = val
        break
      }
    }

    config.handlePantsInput(_obj, "dimensions", idx)
  }
  return (
    <Table bordered>
      <tbody>
        <tr>
          <td style={{ minWidth: 105, position: "relative" }}>
            <Input
              type="text"
              style={{ paddingLeft: 30 }}
              onChange={e => config.handlePantsInput(e, "tg")}
              value={config.payload?.pants?.tg}
              onBlur={e => config.onTgBlur(e, ["トラウザーズ", "pants"])}
              disabled={config.payload.type === "Bespoke"}
            />
            <span
              style={{ position: "absolute", left: 16, top: 18, opacity: 0.5 }}
            >
              Tg
            </span>
          </td>
          <td>
            <p className="mb-0">{config.payload.type === "Bespoke" ? "ヌード" : "ゲージ寸法."} </p>
          </td>
          <td>
            <p className="mb-0">補正値</p>
          </td>
          <td>
            <p className="mb-0">上り寸法</p>
          </td>
        </tr>
        {config.orderSheets?.pants?.dimensions.length &&
          config.orderSheets?.pants?.dimensions
            ?.filter(dim => dim.item)
            .map((obj, idx) => {
              const payloadDim = config.payload.pants.dimensions
              return (
                <tr key={idx}>
                  <td style={{ minWidth: 105 }}>
                    <p className="mb-0">{obj?.item || "-"}</p>
                  </td>
                  {["nude", "correctionValue", "riseDimension"].map(t => (
                    <td style={{ padding: 5 }} key={t}>
                      <DimensionInput
                        name={t}
                        onValueChange={(val, name) =>
                          onTextInputChange({ val, name, obj, idx })
                        }
                        value={payloadDim[idx]?.[t]}
                      />
                    </td>
                  ))}
                </tr>
              )
            })}
      </tbody>
    </Table>
  )
}
